// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1Twxw","label":"Labeled_label__2gFiG","divider":"Labeled_divider__TOvGK"};